module.exports = __webpack_public_path__ + "img/bianjing.e4206902.png";